export const site = {
  name: 'LuckyBetFR',
  domain: 'luckybetfr.com',
  url: 'https://luckybetfr.com',
  brandLine: 'Offres & avis sur les paris sportifs en France',
  locale: 'fr-FR',
  twitterHandle: '@luckybetfr',
} as const;

export type SiteConfig = typeof site;


